export const getZipcodeFromGeoInfo = (userGeoInfo: string) => {
  const match = userGeoInfo?.match(/zip=(\d{5})/);
  if (match && match[1]) {
    return match[1];
  }
  return '';
};
